  <template>
  <div class="h-full kendo-wrapper-height-adjust">
    <div class="loader" v-if="loading">
      <loading :opacity="0" :active.sync="loading" color="var(--primary-DEFAULT)"></loading>
    </div>
    <localization :language="$i18n.locale">
      <intl :class="{ 'k-grid--footer k-widget k-grid': hasFooter }" :locale="$i18n.locale">
        <Grid
          id="grid"
          ref="grid"
          :class="{ 'k-grid__inner': hasFooter }"
          cellRender="default"
          :edit-field="'inEdit'"
          :expand-field="expandField"
          :selected-field="selectedField"
          :data-items="dataResult"
          :columns="columns"
          :reorderable="true"
          :resizable="true"
          :sortable="kendo.sortable"
          :filterable="kendo.filterable"
          :groupable="groupable"
          :skip="kendo.skip"
          :take="kendo.take"
          :sort="kendo.sort"
          :group="kendo.group"
          :filter="kendo.filter"
          :selectable="true"
          @rowclick="rowclick"
          @datastatechange="datastatechange"
          @columnreorder="columnreorder"
          @selectionchange="selectionchange"
          @sortchange="sortchange"
          @headerselectionchange="headerselectionchange"
          @expandchange="expandchange"
          @columnresize="updateFooterStyle"
          @scroll="scroll">
          <template v-slot:default="{ props }">
                <CommonTemplate :set="col = getColumn(props)"
                  :single="single"
                  :field="props.field"
                  :expand-field="expandField"
                  :expanded="props.expanded"
                  :row-type="props.rowType"
                  :level="props.level"
                  :column-index="props.columnIndex"
                  :columns-count="props.columnsCount"
                  :format="props.format || col ? col.format : undefined"
                  :data-item="props.dataItem"
                  :class-name="props.className"
                  :type="props.type"
                  :cell="col ? col.cell : undefined"
                  :extraparams="getExtra(props, col)"
                  :select-on-row-click="selectOnRowClick"
                  :table-id="_uid"
                  @click="clickHandler(props.dataItem)"
                  @expandchange="expandchange"
                  @fieldchange="onFieldChange"
                ></CommonTemplate>
          </template>
          <template v-slot:myButtomTemplate="{ props }">
            <custom v-if="props.dataItem && !props.dataItem.aggregates" :class="props.className" :data-item="props.dataItem" @actionselect="actionSelected" />
          </template>
          <template v-slot:actionsTemplate="{ props }">
            <ActionsTemplate 
              v-if="props.dataItem && !props.dataItem.aggregates"
              :class="props.className"
              :field="props.field"
              :expanded="props.expanded"
              :row-type="props.rowType"
              :level="props.level"
              :column-index="props.columnIndex"
              :columns-count="props.columnsCount"
              :format="props.format"
              :data-item="props.dataItem"
              :class-name="props.className"
              :extraparams="getExtra(props)"
              @click="clickHandler(props.dataItem)"
              @actionclick="actionClicked">
            </ActionsTemplate>
          </template>
          <template v-slot:fechaTemplate="{ props }">
                <FechaTemplate
                  :field="props.field"
                  :expanded="props.expanded"
                  :row-type="props.rowType"
                  :level="props.level"
                  :column-index="props.columnIndex"
                  :columns-count="props.columnsCount"
                  :format="props.format"
                  :data-item="props.dataItem"
                  :class-name="props.className"
                  :extraparams="getExtra(props)"
                  @click="clickHandler(props.dataItem)"
                ></FechaTemplate>
          </template>
          <template v-slot:numberTemplate="{ props }">
                <NumberTemplate
                  :field="props.field"
                  :expanded="props.expanded"
                  :row-type="props.rowType"
                  :level="props.level"
                  :column-index="props.columnIndex"
                  :columns-count="props.columnsCount"
                  :format="props.format"
                  :data-item="props.dataItem"
                  :class-name="props.className"
                  :extraparams="getExtra(props)"
                  @click="clickHandler(props.dataItem)"
                ></NumberTemplate>
          </template>
          <template v-slot:checkboxTemplate="{ props }">
                <CheckboxTemplate
                  :field="props.field"
                  :expanded="props.expanded"
                  :row-type="props.rowType"
                  :level="props.level"
                  :column-index="props.columnIndex"
                  :columns-count="props.columnsCount"
                  :format="props.format"
                  :data-item="props.dataItem"
                  :class-name="props.className"
                  :extraparams="getExtra(props)"
                  @click="clickHandler(props.dataItem)"
                ></CheckboxTemplate>
          </template>
          <template v-slot:tagsTemplate="{ props }">
                <TagsTemplate
                  :field="props.field"
                  :expanded="props.expanded"
                  :row-type="props.rowType"
                  :level="props.level"
                  :column-index="props.columnIndex"
                  :columns-count="props.columnsCount"
                  :format="props.format"
                  :data-item="props.dataItem"
                  :class-name="props.className"
                  :extraparams="getExtra(props)"
                  @click="clickHandler(props.dataItem)"
                ></TagsTemplate>
          </template>
          <template v-slot:groupsTemplate="{ props }">
                <GroupsTemplate
                  :field="props.field"
                  :expanded="props.expanded"
                  :row-type="props.rowType"
                  :level="props.level"
                  :column-index="props.columnIndex"
                  :columns-count="props.columnsCount"
                  :format="props.format"
                  :data-item="props.dataItem"
                  :class-name="props.className"
                  :extraparams="getExtra(props)"
                  @click="clickHandler(props.dataItem)"
                ></GroupsTemplate>
          </template>
          <template v-slot:enumTemplate="{ props }">
                <EnumTemplate
                  :field="props.field"
                  :expanded="props.expanded"
                  :row-type="props.rowType"
                  :level="props.level"
                  :column-index="props.columnIndex"
                  :columns-count="props.columnsCount"
                  :format="props.format"
                  :data-item="props.dataItem"
                  :class-name="props.className"
                  :extraparams="getExtra(props)"
                  @click="clickHandler(props.dataItem)"
                ></EnumTemplate>
          </template>
          <template v-slot:myTemplate="{ props }">
            <ColumnMenu :column="props.column" :filterable="props.filterable" :filter="props.filter" :sortable="props.sortable" :sort="props.sort" :columns="menuColumns" @closemenu="(e) => props.onClosemenu(e)" @columnssubmit="columnssubmit" @sortchange="sortchange" @filterchange="filterchange" />
          </template>
          <template v-slot:myTemplateNoCol="{ props }">
            <ColumnMenu :column="props.column" :filterable="props.filterable" :filter="props.filter" :sortable="props.sortable" :sort="props.sort" @closemenu="(e) => props.onClosemenu(e)" @sortchange="sortchange" @filterchange="filterchange" />
          </template>
          <!-- <template v-slot:basic="{ props }">
            <CellComponent
                  :field="props.field"
                  :expanded="props.expanded"
                  :row-type="props.rowType"
                  :level="props.level"
                  :column-index="props.columnIndex"
                  :columns-count="props.columnsCount"
                  :data-item="props.dataItem"
                  :class-name="props.className"
                  @click="clickHandler(props.dataItem)"
                ></CellComponent>
          </template> -->
          <grid-norecords>
            {{ noRecords }}
          </grid-norecords>
        </Grid>
        <div v-if="hasFooter" class="k-grid-footer" style="padding: 0px 8px 0px 0px;">
          <div ref="footerwrap" class="k-grid-footer-wrap">
            <table ref="footertable">
              <colgroup ref="colgroup" />
              <tfoot>
                <slot name="kendofooter" :max-columns="visibleColumnsCount" />
              </tfoot>
            </table>
          </div>
        </div>
      </intl>
    </localization>
  </div>
</template>

<script>
import { i18n } from '@/i18n'
import { Grid, GridNoRecords } from '@progress/kendo-vue-grid'
import ColumnMenu from '@/components/kendo/ColumnMenu.vue'
import { IntlProvider, LocalizationProvider, loadMessages } from '@progress/kendo-vue-intl'
import gridKendo from '@/config/grid-kendo.js'
import Loading from 'vue-loading-overlay'
import ActionCell from './ActionCell'
import CheckboxTemplate from '@/components/kendo/templates/CheckboxTemplate.vue'
import FechaTemplate from '@/components/kendo/templates/FechaTemplate.vue'
import CommonTemplate from '@/components/kendo/templates/CommonTemplate.vue'
import NumberTemplate from '@/components/kendo/templates/NumberTemplate.vue'
import TagsTemplate from '@/components/kendo/templates/TagsTemplate.vue'
import GroupsTemplate from '@/components/kendo/templates/GroupsTemplate.vue'
import EnumTemplate from '@/components/kendo/templates/EnumTemplate.vue'
import ActionsTemplate from '@/components/kendo/templates/ActionsTemplate.vue'
// import CellComponent from '@/components/kendo/CellComponent.vue'

import getNestedValue from '@/services/functions/getNestedValue'

import { TIPOS_ONLY } from '@/config/tipos-only'

Object.entries(gridKendo).forEach(([locale, messages]) => loadMessages(messages, locale))

export default {
  name: 'kendo-grid-component',
  components: {
    Grid: Grid,
    'grid-norecords': GridNoRecords,
    ColumnMenu,
    localization: LocalizationProvider,
    intl: IntlProvider,
    Loading,
    custom: ActionCell,
    CheckboxTemplate,
    FechaTemplate,
    NumberTemplate,
    TagsTemplate,
    GroupsTemplate,
    EnumTemplate,
    ActionsTemplate,
    CommonTemplate,
  },
  props: {
    dataResult: {
      type: [Array, Object],
      default: null
    },
    kendo: {},
    selectedField: {
      type: String,
      default: 'selected'
    },
    loading: {
      type: Boolean,
      default: false
    },
    single: {
      type: Boolean,
      default: false
    },
    selectOnRowClick: {
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      noRecords: i18n.t('app.not_avaliable_data'),
      tiposOnly: TIPOS_ONLY,
      expandField: 'expanded',
      group: this.kendo.group || [],
    }
  },
  computed: {
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    menuColumns: function () {
      return this.columns.filter(c => c.title)
    },
    noMenuColumns: function () {
      return this.columns.filter(c => !c.title)
    },
    groupable: function () {
      if (Object.prototype.hasOwnProperty.call(this.kendo, 'groupable')) {
        return this.kendo.groupable
      }
      return true
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    numDynamicColumns: function () {
      return 4
    },
    widthStaticColumns: function () {
      return 100
    },
    columns: function () {
      const empty = () => true
      return this.kendo.columns.filter(x => 
        !Object.keys(x.only || {}).length || 
        Object.keys(x.only).every(key => (this.tiposOnly[key] || empty)({ items: x.only[key], store: this.$store, route: this.$route, data: this.dataResult?.data }))
      )
    },
    hasFooter: function () {
      return !!this.$slots.kendofooter || !!this.$scopedSlots.kendofooter
    },
    visibleColumnsCount: function () {
      if (!this.hasFooter) {
        return ''
      }
      return this.columns.filter(x => !x.hidden).length
    },
  },
  watch: {},
  mounted: function () {
    this.grid = this.$refs.grid
    this.$root.$on('kendo-grid-componente-handle-resize', () => {
      this.handleResize()
    })
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    if (this.hasFooter) {
      this.updateFooterColGroup()
      this.updateFooterStyle()
    }
  },
  created: function () {
    if (this.kendo.navigate === true) {
      const index = this.kendo.columns.findIndex((x) => x.cell === 'myButtomTemplate')
      // if (index === -1) this.columns.splice(1, 0, { field: ' ', title: '', cell: 'myButtomTemplate', filterable: false, width: '125px', locked: true, reorderable: false, groupable: false, sortable: false })
      if (index === -1) {
        if (this.kendo.columns[0].field === this.selectedField) this.kendo.columns.splice(1, 0, { field: ' ', title: '', cell: 'myButtomTemplate', filterable: false, width: '125px', locked: true, reorderable: false, groupable: false, sortable: false })
        else this.kendo.columns.splice(0, 0, { field: ' ', title: '', cell: 'myButtomTemplate', filterable: false, width: '125px', locked: true, reorderable: false, groupable: false, sortable: false })
      } 
    }
  },
  methods: {
    datastatechange: function (event) {
      this.$emit('datastatechange', event)
    },
    columnreorder: function (event) {
      if (this.hasFooter) {
        this.updateFooterColGroup()
        this.updateFooterStyle()
      }
      this.$emit('columnreorder', event)
    },
    expandchange: function (event) {
      // this.$emit('expandchange', event)
      this.$set(
        event.dataItem,
        event.target.$props.expandField,
        event.dataItem.expanded === undefined ? false : !event.dataItem.expanded
      )
    },
    rowclick: function (event) {
      if (this.selectOnRowClick) {
        this.onFieldChange({ event: event.event, dataItem: event.dataItem, field: this.selectedField })
      }
      // this.$emit('rowclick', event)
    },
    columnssubmit: function (event) {
      const columns = this.noMenuColumns.concat(event)
      this.$emit('columnssubmit', columns)
    },
    sortchange: function (event) {
      this.$emit('sortchange', event)
    },
    filterchange: function (event) {
      this.$emit('filterchange', event)
    },
    selectionchange: function (event) {
      this.$emit('selectionchange', event)
    },
    headerselectionchange: function (event) {
      this.$emit('headerselectionchange', event)
    },
    actionSelected: function (e) {
      this.$emit('rowclick', e)
    },
    actionClicked: function (e) {
      this.$emit('actionclick', e)
    },
    handleResize: function () {
      // const self = this
      // setTimeout(() => {
      //   if (self.grid !== undefined) {
      //     const currentVisibleColumns = self.columns.filter((c) => !(c.minGridWidth > self.grid.offsetWidth))
      //     if (currentVisibleColumns.length !== self.columns.length) {
      //       self.kendo.columns = currentVisibleColumns
      //     }
      //     const mapedColumns = self.columns.map(column => {
      //       if (self.isLower1024) {
      //         if (column.minWidth !== undefined && column.minWidth !== null) {
      //           column.width = column.minWidth
      //         }
      //       } else {
      //         if (column.minWidth !== undefined && column.minWidth !== null) {
      //           const topWidth = document.querySelector('#grid > div.k-grouping-header.k-grouping-header-flex').clientWidth
      //           column.width = ((topWidth - self.widthStaticColumns) / self.numDynamicColumns) + 'px'
      //           // column.width = '100%'
      //           // delete column.width
      //         } 
      //       }
      //       return column
      //     })
      //     self.kendo.columns = mapedColumns
      //   }
      // }, 50)
      if (this.grid !== undefined) {
        const currentVisibleColumns = this.columns.filter((c) => !(c.minGridWidth > this.grid.offsetWidth))
        if (currentVisibleColumns.length !== this.columns.length) {
          this.kendo.columns = currentVisibleColumns
        }
      }
    },
    scroll: function (e) {
      if (this.hasFooter && this.$refs.footerwrap) {
        this.$refs.footerwrap.scrollLeft = e.target.scrollLeft
      }
    },
    updateFooterColGroup: function () {
      if (this.hasFooter && this.$refs.colgroup) {
        if (!this.$refs.grid || !this.$refs.grid.$refs.colGroup) {
          this.$refs.colgroup.innerHTML = this.columns.map(col => `<col key="${col.field || col.title}" ${col.hidden ? 'hidden' : ''} width="${col.width}" />`).join('')
        } else {
          const self = this
          try {
            this.$nextTick(() => {
              while (self.$refs.colgroup.childElementCount > 0) {
                self.$refs.colgroup.childNodes[0].remove()
              }
              self.$refs.grid.$refs.colGroup.childNodes.forEach(x => self.$refs.colgroup.appendChild(x.cloneNode(true)))
            })
          } catch (error) {
            console.log('CustomLog: error', error)
          }
        } 
      }
    },
    updateFooterStyle: function () {
      if (this.hasFooter && this.$refs.colgroup) {
        if (!this.$refs.grid || !this.$refs.grid.$refs.colGroup) {
          self.$refs.footertable.style.width = this.columns.filter(x => !x.hidden).map(x => x.width).join(' + ')
        } else {
          const self = this
          try {
            this.$nextTick(() => {
              const width = self.$refs.grid.$refs.colGroup.parentNode.style.width
              self.$refs.footertable.style.width = width
              self.$refs.grid.$refs.colGroup.childNodes.forEach((x, i) => self.$refs.colgroup.childNodes[i].setAttribute('width', x.getAttribute('width')))
            })
          } catch (error) {
            console.log('CustomLog: error', error)
          }
        } 
      }
    },
    getColumn: function (props) {
      var column
      if (this.columns[props.columnIndex]?.field === props.field) {
        column = this.columns[props.columnIndex]
      } else if (props.rowType === 'groupHeader') {
        column = this.columns.find(x => props.dataItem.field === x.field)
      } else {
        column = this.columns.find(x => props.field === x.field)
      }
      return column
    },
    getExtra: function (props, column) {
      if (!props) {
        return undefined
      }
      if (!column) {
        column = this.getColumn(props)
      }
      return column ? { ...column.extraparams, title: column.title, field: column.field } : {}
    },
    getNestedValue: function (fieldName, dataItem) {
      return getNestedValue(fieldName, dataItem) // Object.prototype.hasOwnProperty.call(dataItem, fieldName) ? dataItem[fieldName] : false
    },
    onFieldChange: function ({ event, dataItem, field }) {
      if (field === this.selectedField) {
        var dataItems = this.dataResult.data
        this.kendo.group.forEach(_ => { dataItems = dataItems.flatMap(x => x.items) })
        this.$emit('selectionchange', { dataItems, event, dataItem })
      }
    },
    clickHandler: function (e, dataItem, expanded) {
      // this.$emit('expandchange')
    },
  },
  beforeDestroy () {
    if (this.kendo) {
      if (this.kendo.dataResult) {
        this.kendo.dataResult = null
      }
      if (this.kendo.columns?.[0]) {
        this.kendo.columns[0].headerSelectionValue = false
      }
    }
  },
}
</script>

<style lang="scss">
.kendo-wrapper-height-adjust {
  & > div:not(.vld-overlay) {
    height: 100%;
    & > div:not(.vld-overlay) {
      height: 100%;
    }
  }
}
.k-grid {
  height: 100%;
}
</style>
